import React from 'react';
import { Link } from 'react-router-dom';
import useFadeIn from '../hooks/useFadeIn';
import { buildSignupPath, buildSignupState, captureCtaClick } from '../utils/analytics';

function ClosingCTA() {
  const [ref, isVisible] = useFadeIn();

  return (
    <section className="relative overflow-hidden bg-[#1d1d1f] px-8 md:px-16 py-20 md:py-28">

      {/* Subtle ambient gradient */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-gradient-to-br from-blue-600/15 via-purple-600/10 to-transparent blur-3xl pointer-events-none" />

      <div
        ref={ref}
        className={`fade-in-section ${isVisible ? 'is-visible' : ''} relative z-10 max-w-[1440px] mx-auto flex flex-col items-center text-center gap-8`}
      >

        <h2 className="text-3xl md:text-4xl xl:text-[52px] xl:leading-[1.08] text-white leading-snug max-w-[700px]">
          Ready to transform your prescribing workflow?
        </h2>

        <p className="text-lg text-[#a1a1a6] leading-relaxed max-w-xl font-normal">
          Join healthcare teams already using MedHug to make medications more accessible and affordable.
        </p>

        <div className="flex items-center gap-5 mt-4">
          <Link
            to={buildSignupPath()}
            state={buildSignupState('closing-get-started')}
            data-ph-capture-attribute-cta="closing-get-started"
            onClick={() => captureCtaClick('closing-get-started', { placement: 'closing-cta' })}
            className="bg-white px-8 py-[14px] text-[15px] font-medium text-[#1d1d1f] hover:bg-gray-100 transition-all whitespace-nowrap rounded-full shadow-lg shadow-white/10 hover:shadow-xl hover:-translate-y-[1px]"
          >
            Get Started
          </Link>
          <Link
            to={buildSignupPath()}
            state={buildSignupState('closing-book-demo')}
            data-ph-capture-attribute-cta="closing-book-demo"
            onClick={() => captureCtaClick('closing-book-demo', { placement: 'closing-cta' })}
            className="px-8 py-[14px] text-[15px] font-medium text-[#2997ff] hover:text-[#6cb6ff] transition-all whitespace-nowrap"
          >
            Book a Demo →
          </Link>
        </div>

      </div>
    </section>
  );
}

export default ClosingCTA;
